// crm namespace — Clients list: header, saved views, bulk bar, Add client slide-over.
// Flat dotted keys, the same set in fr / en / es (i18n/__tests__/symmetry.test.js).
export default {
  fr: {
    "add.birthday": "Anniversaire (jour + mois)",
    "add.birthdayDay": "Jour de l'anniversaire",
    "add.birthdayMonth": "Mois de l'anniversaire",
    "add.created": "{name} ajouté",
    "add.day": "Jour",
    "add.email": "E-mail",
    "add.errEmailInvalid": "Vérifiez l'adresse e-mail",
    "add.errEmailRequired": "Saisissez une adresse e-mail.",
    "add.errNameRequired": "Saisissez un nom.",
    "add.errTooLong": "C'est trop long.",
    "add.exists": "Ce client existe déjà —",
    "add.month": "Mois",
    "add.name": "Nom",
    "add.openRecord": "ouvrir la fiche",
    "add.phone": "Téléphone",
    "add.stage": "Étape",
    "add.tags": "Étiquettes",
    "add.tagsPlaceholder": "Saisissez une étiquette puis Entrée",
    "add.title": "Ajouter un client",
    "bulk.addTag": "Ajouter une étiquette",
    "bulk.addTagTitle": "Ajouter une étiquette à {n} clients",
    "bulk.addToSequence": "Ajouter à une séquence",
    "bulk.changeStage": "Changer l'étape",
    "bulk.chooseSequence": "Choisissez une séquence",
    "bulk.clear": "Effacer la sélection",
    "bulk.consentedOnly": "Seuls les clients consentants sont ajoutés ; les autres sont ignorés.",
    "bulk.done": "Fait pour {n} clients ({skipped} ignorés)",
    "bulk.exportSelected": "Exporter la sélection",
    "bulk.noSequences": "Aucune séquence n'est prête. Les séquences arrivent avec l'automatisation des e-mails.",
    "bulk.removeTag": "Retirer une étiquette",
    "bulk.removeTagTitle": "Retirer une étiquette de {n} clients",
    "bulk.selectAllMatching": "Sélectionner les {n} correspondants",
    "bulk.selected": "{n} sélectionnés",
    "bulk.sequence": "Séquence",
    "bulk.sequenceTitle": "Ajouter {n} clients à une séquence",
    "bulk.stageManualHint": "Une étape choisie à la main reste en place jusqu'à « Reprendre l'automatique » sur la fiche.",
    "bulk.stageTitle": "Changer l'étape de {n} clients",
    "bulk.tag": "Étiquette",
    "clients.add": "+ Ajouter un client",
    "clients.colActivity": "Dernière activité",
    "clients.colEmail": "E-mail",
    "clients.colName": "Nom",
    "clients.colPack": "Solde du forfait",
    "clients.colSpend": "Dépenses totales",
    "clients.colStage": "Étape",
    "clients.colTags": "Étiquettes",
    "clients.empty": "Aucun client pour l'instant",
    "clients.emptyBody": "Importez votre liste ou ajoutez un premier client — les réservations et les achats les ajoutent aussi automatiquement.",
    "clients.emptyFiltered": "Aucun client ne correspond à ces filtres",
    "clients.export": "Exporter en CSV",
    "clients.import": "Importer",
    "clients.search": "Rechercher un nom, un e-mail, un téléphone",
    "clients.searchHint": "Les résultats se mettent à jour après {n} caractères.",
    "clients.title": "Clients",
    "views.errNameRequired": "Donnez un nom à la vue.",
    "views.menu": "Vues enregistrées",
    "views.name": "Nom de la vue",
    "views.saveCurrent": "Enregistrer la vue actuelle",
    "views.saveTitle": "Enregistrer cette vue",
    "views.saved": "Vue « {name} » enregistrée",
  },
  en: {
    "add.birthday": "Birthday (day + month)",
    "add.birthdayDay": "Birthday day",
    "add.birthdayMonth": "Birthday month",
    "add.created": "{name} added",
    "add.day": "Day",
    "add.email": "Email",
    "add.errEmailInvalid": "Check your email address",
    "add.errEmailRequired": "Enter an email address.",
    "add.errNameRequired": "Enter a name.",
    "add.errTooLong": "This is too long.",
    "add.exists": "Client exists —",
    "add.month": "Month",
    "add.name": "Name",
    "add.openRecord": "open record",
    "add.phone": "Phone",
    "add.stage": "Stage",
    "add.tags": "Tags",
    "add.tagsPlaceholder": "Type a tag, then Enter",
    "add.title": "Add client",
    "bulk.addTag": "Add tag",
    "bulk.addTagTitle": "Add a tag to {n} clients",
    "bulk.addToSequence": "Add to sequence",
    "bulk.changeStage": "Change stage",
    "bulk.chooseSequence": "Choose a sequence",
    "bulk.clear": "Clear selection",
    "bulk.consentedOnly": "Only consented clients are added; the others are skipped.",
    "bulk.done": "Done for {n} clients ({skipped} skipped)",
    "bulk.exportSelected": "Export selected",
    "bulk.noSequences": "No sequence is ready yet. Sequences arrive with Email Automation.",
    "bulk.removeTag": "Remove tag",
    "bulk.removeTagTitle": "Remove a tag from {n} clients",
    "bulk.selectAllMatching": "Select all {n} matching",
    "bulk.selected": "{n} selected",
    "bulk.sequence": "Sequence",
    "bulk.sequenceTitle": "Add {n} clients to a sequence",
    "bulk.stageManualHint": "A stage set by hand stays until you choose Resume automatic on the client.",
    "bulk.stageTitle": "Change the stage of {n} clients",
    "bulk.tag": "Tag",
    "clients.add": "+ Add client",
    "clients.colActivity": "Last activity",
    "clients.colEmail": "Email",
    "clients.colName": "Name",
    "clients.colPack": "Pack balance",
    "clients.colSpend": "Lifetime spend",
    "clients.colStage": "Stage",
    "clients.colTags": "Tags",
    "clients.empty": "No clients yet",
    "clients.emptyBody": "Import your list or add your first client — bookings and purchases add them automatically too.",
    "clients.emptyFiltered": "No clients match these filters",
    "clients.export": "Export CSV",
    "clients.import": "Import",
    "clients.search": "Search name, email, phone",
    "clients.searchHint": "Results update after {n} characters.",
    "clients.title": "Clients",
    "views.errNameRequired": "Give the view a name.",
    "views.menu": "Saved views",
    "views.name": "View name",
    "views.saveCurrent": "Save current view",
    "views.saveTitle": "Save this view",
    "views.saved": "View \"{name}\" saved",
  },
  es: {
    "add.birthday": "Cumpleaños (día + mes)",
    "add.birthdayDay": "Día del cumpleaños",
    "add.birthdayMonth": "Mes del cumpleaños",
    "add.created": "{name} añadido",
    "add.day": "Día",
    "add.email": "Correo",
    "add.errEmailInvalid": "Revisa la dirección de correo",
    "add.errEmailRequired": "Escribe un correo.",
    "add.errNameRequired": "Escribe un nombre.",
    "add.errTooLong": "Es demasiado largo.",
    "add.exists": "El cliente ya existe:",
    "add.month": "Mes",
    "add.name": "Nombre",
    "add.openRecord": "abrir la ficha",
    "add.phone": "Teléfono",
    "add.stage": "Etapa",
    "add.tags": "Etiquetas",
    "add.tagsPlaceholder": "Escribe una etiqueta y pulsa Intro",
    "add.title": "Añadir cliente",
    "bulk.addTag": "Añadir etiqueta",
    "bulk.addTagTitle": "Añadir una etiqueta a {n} clientes",
    "bulk.addToSequence": "Añadir a una secuencia",
    "bulk.changeStage": "Cambiar etapa",
    "bulk.chooseSequence": "Elige una secuencia",
    "bulk.clear": "Borrar selección",
    "bulk.consentedOnly": "Solo se añaden los clientes con consentimiento; el resto se omite.",
    "bulk.done": "Hecho para {n} clientes ({skipped} omitidos)",
    "bulk.exportSelected": "Exportar selección",
    "bulk.noSequences": "Aún no hay ninguna secuencia. Llegan con la automatización de correos.",
    "bulk.removeTag": "Quitar etiqueta",
    "bulk.removeTagTitle": "Quitar una etiqueta a {n} clientes",
    "bulk.selectAllMatching": "Seleccionar los {n} que coinciden",
    "bulk.selected": "{n} seleccionados",
    "bulk.sequence": "Secuencia",
    "bulk.sequenceTitle": "Añadir {n} clientes a una secuencia",
    "bulk.stageManualHint": "Una etapa elegida a mano se mantiene hasta que elijas «Reanudar automático» en la ficha.",
    "bulk.stageTitle": "Cambiar la etapa de {n} clientes",
    "bulk.tag": "Etiqueta",
    "clients.add": "+ Añadir cliente",
    "clients.colActivity": "Última actividad",
    "clients.colEmail": "Correo",
    "clients.colName": "Nombre",
    "clients.colPack": "Saldo del bono",
    "clients.colSpend": "Gasto total",
    "clients.colStage": "Etapa",
    "clients.colTags": "Etiquetas",
    "clients.empty": "Aún no hay clientes",
    "clients.emptyBody": "Importa tu lista o añade tu primer cliente: las reservas y las compras también los añaden automáticamente.",
    "clients.emptyFiltered": "Ningún cliente coincide con estos filtros",
    "clients.export": "Exportar CSV",
    "clients.import": "Importar",
    "clients.search": "Buscar nombre, correo, teléfono",
    "clients.searchHint": "Los resultados se actualizan a partir de {n} caracteres.",
    "clients.title": "Clientes",
    "views.errNameRequired": "Pon un nombre a la vista.",
    "views.menu": "Vistas guardadas",
    "views.name": "Nombre de la vista",
    "views.saveCurrent": "Guardar la vista actual",
    "views.saveTitle": "Guardar esta vista",
    "views.saved": "Vista «{name}» guardada",
  },
};
